import React from "react";
import { history } from "model";
import { ROUTS } from "./routs";
import { Trans } from "@lingui/macro";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";
import { LoginPage } from "../components/pages/LoginPage";
import { DashboardPage } from "../components/pages/DashboardPage";
import { NOTIFICATION_MESSAGES } from "../model/system/constants";
import { Notification } from "../components/UI/Notification/Notification";
import { deleteNotificationAC } from "../model/system/systemActionCreators";
import { ForgotPasswordPage } from "../components/pages/ForgonPasswordPage";
import { selectAuth, selectNotificationList } from "../model/system/selectors";

const NotificationList: React.FC = () => {
  const dispatch = useDispatch();
  const notificationList = useSelector(selectNotificationList);

  return notificationList.length
    ? createPortal(
        <div
          aria-live="assertive"
          className="fixed z-50 inset-0 flex flex-col gap-y-4 items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start"
        >
          {notificationList.map((item, index) => {
            const title = NOTIFICATION_MESSAGES[item.message]?.title || (
              <Trans>Error</Trans>
            );

            const message =
              NOTIFICATION_MESSAGES[item.message]?.message || item.message;

            const type = NOTIFICATION_MESSAGES[item.message]?.type || "error";

            const deleteNotification = () => {
              dispatch(deleteNotificationAC(item.id));
            };

            return (
              <div
                key={item.id}
                className={`absolute top-${index * 8 + 4} right-5 w-full`}
              >
                <Notification
                  type={type}
                  title={title}
                  message={message}
                  deleteNotification={deleteNotification}
                />
              </div>
            );
          })}
        </div>,
        document.body,
      )
    : null;
};

export const MainRouter: React.FC = () => {
  const auth = useSelector(selectAuth);

  return (
    <Router history={history}>
      {auth ? (
        <Switch>
          <Route path={ROUTS.HOME_PAGE} component={DashboardPage} />
        </Switch>
      ) : (
        <Switch>
          <Route
            component={ForgotPasswordPage}
            path={ROUTS.FORGOT_PASSWORD_PAGE}
          />
          <Route path={ROUTS.HOME_PAGE} component={LoginPage} />
        </Switch>
      )}
      <NotificationList />
    </Router>
  );
};
